import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  parent_reservationsData: any;
  parent_reservationsLoading: boolean;
  parent_reservationsError: SerializedError | null;
  page: number;
} = {
  parent_reservationsData: {},
  parent_reservationsLoading: false,
  parent_reservationsError: null,
  page: 1,
};

export const parent_reservationsFunc = createAsyncThunk(
  'parent_reservations/parent_reservationsFunc',
  async () => {
    const accessTokenJSON = localStorage.getItem('auth') as string;
    const data1 = JSON.stringify({
      query: `query Parent_reservations($filter: FilterReservationByParentInput, $pagination: Pagination) {
      parent_reservations(filter: $filter, pagination: $pagination) {
        count
        data {
        _id
        createdAt
        imageUrl
        parent {
            _id
            description
            displayImageUrl
            displayName
            role
        }
        status
        updatedAt
        activity {
            _id
            title
            listing {
            _id
            title
            ageInterval
            coverImage
            images
            }
            schedule {
            _id
            endDate
            startDate
            days {
                _id
                endTime
                startTime
            }
            }
            location {
            _id
            city
            address {
                title
            }
            }
            price
        }
        }
      }
    }`,
      variables: {
        filter: {
          dateInterval: {
            from: null,
            to: null,
          },
          status: null,
        },
        pagination: {
          page: null,
          pageSize: null,
          sort: null,
        },
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      JSON.parse(accessTokenJSON)?.accessToken || ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const parent_reservations = createSlice({
  name: 'parent_reservations',
  initialState,
  reducers: {
    setPaginationParent: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(parent_reservationsFunc.pending, (state) => {
      state.parent_reservationsLoading = true;
    });
    builder.addCase(parent_reservationsFunc.fulfilled, (state, action) => {
      state.parent_reservationsLoading = false;
      state.parent_reservationsData = action.payload?.data?.parent_reservations;
      state.parent_reservationsError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(parent_reservationsFunc.rejected, (state, action) => {
      state.parent_reservationsLoading = false;
      state.parent_reservationsError = action.error;
    });
  },
});

export const { setPaginationParent } = parent_reservations.actions;
export default parent_reservations.reducer;
